import {TEMPLATE_ID_HEADER} from '../../utils/constants';

export const SET_PROPERTY_TYPE_IMAGE_URL = 'SET_PROPERTY_TYPE_IMAGE_URL';

// actions
export function setPropertyTypesImages(payload) {
    return {
        type: SET_PROPERTY_TYPE_IMAGE_URL,
        payload,
    };
}

export function fetchImagesByTags({basePathPrefix, items = []}) {
    return (dispatch, getState) => {
        const {
            config: {template},
        } = getState();
        const tag = items.map((item) => `tags=${item.messageKey}`).join('&');

        const pathName = `${basePathPrefix}/api/property-type-images?${tag}`;
        return fetch(pathName, {
            credentials: 'same-origin',
            headers: {
                [TEMPLATE_ID_HEADER]: template,
            },
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed loading property type images');
                }

                return res.json();
            })
            .then((payload) => {
                dispatch(setPropertyTypesImages(payload));
            })
            .catch((err) => console.log(err)); // eslint-disable-line no-console
    };
}

// reducers
export default function propertyTypes(state = {}, action) {
    switch (action.type) {
        case SET_PROPERTY_TYPE_IMAGE_URL:
            return {
                ...state,
                imagesUrls: action.payload,
            };
        default:
            return state;
    }
}
